import React, { useEffect, useRef } from "react";
import { Button, ButtonGroup } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import {
  FaBold,
  FaItalic,
  FaUnderline,
  FaListUl,
  FaListOl,
} from "react-icons/fa";
import { PROPOSAL_SET_VALUES } from "../../store/constants/proposalConstants";

export const DEFAULT_DISCLOSURE_HTML = `<h4>GENERAL NOTES</h4>
<ul>
<li>If Non-Punch List Items Create the Need for Repeat Work, An Additional Charge May Be Assessed.</li>
<li>Bidder included sales tax.</li>
<li>Project schedule understood and accepted.</li>
<li>Bidder has included all costs to meet the schedule and accounts for all overtime and shift time necessary to complete work and make up for delays that are through no fault of others.</li>
</ul>
<h4>EXCLUSIONS</h4>
<ul>
<li>Dumpster removal.</li>
<li>Out of scope work, such as:
<ul>
<li>Power washing exterior walkways.</li>
<li>Exterior signs.</li>
</ul>
</li>
</ul>`;

const SignatureBlock = ({ disable_fields }) => {
  const proposalValues = useSelector((state) => state.proposalValues);
  const sections = useSelector((state) => state.proposalSections);
  const userDetails = useSelector((state) => state.userDetails);
  const { user } = userDetails;
  const { projectTypes: userProjectTypes, loading: userProjectTypesLoading } =
    useSelector((state) => state.userProjectTypeList);
  const dispatch = useDispatch();
  const editorRef = useRef(null);

  const applyDisclosure = (html) => {
    if (editorRef.current && editorRef.current.innerHTML !== html) {
      editorRef.current.innerHTML = html;
    }
    if (proposalValues?.user_disclosure !== html) {
      dispatch({
        type: PROPOSAL_SET_VALUES,
        payload: { user_disclosure: html },
      });
    }
  };

  useEffect(() => {
    if (proposalValues?.user_disclosure) {
      if (
        editorRef.current &&
        document.activeElement !== editorRef.current &&
        editorRef.current.innerHTML !== proposalValues.user_disclosure
      ) {
        editorRef.current.innerHTML = proposalValues.user_disclosure;
      }
      return;
    }
    if (userProjectTypesLoading !== false) {
      return;
    }
    const saved = (userProjectTypes || []).find(
      (item) => item?.name?.toLowerCase() === "disclosure"
    );
    applyDisclosure(saved?.user_template || DEFAULT_DISCLOSURE_HTML);
  }, [
    proposalValues?.user_disclosure,
    userProjectTypesLoading,
    userProjectTypes,
  ]);

  const handleEditorBlur = () => {
    if (!editorRef.current || disable_fields) {
      return;
    }
    applyDisclosure(editorRef.current.innerHTML);
  };

  const handleFormat = (command) => (event) => {
    event.preventDefault();
    editorRef.current?.focus();
    document.execCommand(command, false, null);
  };

  return (
    <div
      style={{
        fontSize: "16px",
        textTransform: "capitalize",
        marginTop: "10px",
      }}
    >
      {sections.davis_bacon && (
        <div style={{ fontSize: "14px" }}>
          <p>
            We adhere fully to all federal contracting requirements. Certified
            Payroll, and Davis Bacon Wages.
          </p>
        </div>
      )}
      {sections.union_requirement && (
        <div style={{ fontSize: "14px" }}>
          <p>
            This price reflects local union agreement labor practices, we will
            provide a Project Labor Agreement (PLA) for this project.
          </p>
        </div>
      )}
      {sections.sign && (
        <div>
          {(sections.davis_bacon || sections.union_requirement) && <br />}
          <h4>Client Approval: </h4>
          <div className="mb-3 mt-3">
            <p>
              Client Name: __________________________________________________
            </p>
          </div>

          <div className="mb-3">
            <p>
              Date: _________________________________________________________
            </p>
          </div>

          <div className="mb-3">
            <p>
              Signature*: ____________________________________________________
            </p>
          </div>
          <p style={{ fontSize: "14px" }}>
            * Signing Indicates Full Agreement with The Project Specifications
            and The Outlined Pricing in The Scope of Work.
          </p>
        </div>
      )}

      <br></br>
      {sections.disclosure && user?.trade === "cleaning" ? (
        <div style={{ marginTop: sections.sign ? "20px" : "" }}>
          {!disable_fields && (
            <div className="d-flex justify-content-between align-items-center mb-2">
              <ButtonGroup>
                <Button
                  variant="light"
                  size="sm"
                  onMouseDown={handleFormat("bold")}
                  title="Bold"
                >
                  <FaBold />
                </Button>
                <Button
                  variant="light"
                  size="sm"
                  onMouseDown={handleFormat("italic")}
                  title="Italic"
                >
                  <FaItalic />
                </Button>
                <Button
                  variant="light"
                  size="sm"
                  onMouseDown={handleFormat("underline")}
                  title="Underline"
                >
                  <FaUnderline />
                </Button>
                <Button
                  variant="light"
                  size="sm"
                  onMouseDown={handleFormat("insertUnorderedList")}
                  title="Bullet List"
                >
                  <FaListUl />
                </Button>
                <Button
                  variant="light"
                  size="sm"
                  onMouseDown={handleFormat("insertOrderedList")}
                  title="Numbered List"
                >
                  <FaListOl />
                </Button>
              </ButtonGroup>
              <Button
                variant="link"
                size="sm"
                onMouseDown={(event) => {
                  event.preventDefault();
                  applyDisclosure(DEFAULT_DISCLOSURE_HTML);
                }}
              >
                Reset to default
              </Button>
            </div>
          )}
          <div
            ref={editorRef}
            contentEditable={!disable_fields}
            suppressContentEditableWarning
            onBlur={handleEditorBlur}
            style={{
              textTransform: "initial",
              minHeight: "80px",
              outline: "none",
              border: disable_fields ? "none" : "1px dashed #c5c5c5",
              borderRadius: "4px",
              padding: disable_fields ? 0 : "8px",
            }}
            dangerouslySetInnerHTML={{
              __html:
                proposalValues?.user_disclosure || DEFAULT_DISCLOSURE_HTML,
            }}
          />
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default SignatureBlock;
